<template>
  <div id="game">
    <div class="game-list nr">
      <div class="center">
        <div class="tit">
          <h2>遊戲區</h2>
        </div>
        <CompMarquee />
        <div class="list">
          <ul>
            <li
              class="game-tn"
              v-for="(game, index) in gameList"
              :key="index"
              @click="getGameUrl(game.game_id)"
            >
              <section>
                <div class="pic">
                  <img :src="game.image" alt="" />
                  <h6>{{ game.name }}</h6>
                </div>
              </section>
            </li>
          </ul>
        </div>
      </div>
      <CompFoot/>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "games",
  components: {
    CompMarquee: require("@/components/parts/Marquee").default,
    CompFoot: require("@/components/parts/Foot").default,
  },
  computed: {
    ...mapState({
      gameList: (state) => state.msgaming.gameList,
      gameUrl: (state) => state.msgaming.gameUrl,
    }),
  },
  methods: {
    async getGameList() {
      await this.$store.dispatch("msgaming/getGameList");
    },
    async getGameUrl(game_id) {
      const loading = this.$loadingCase("連線中")
      const data = {
        token: sessionStorage.token,
        game_id,
        return_url: location.href,
        lang: "",
      };
      await this.$store.dispatch("msgaming/getGameUrl", data);
      loading.close();
      location.href = this.gameUrl
      // window.open(this.gameUrl, "_blank", " width=1300, height=900");
    },
  },
  created() {
    this.getGameList();
  },
};
</script>
<style scoped>
@import "~@/assets/css/game.css";
</style>
